import { j as l } from "./AccesRecoveryIcon-CUPieIxT.js";
const f = () => /* @__PURE__ */ l.jsxs("svg", { viewBox: "0 0 108 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ l.jsx("path", { d: "M80 56c15.464 0 28-12.536 28-28S95.464 0 80 0 52 12.536 52 28s12.536 28 28 28", fill: "#26A17B" }),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      d: "M83.364 30.42v-.003c-.193.014-1.185.073-3.399.073a74 74 0 0 1-3.449-.073v.005c-6.804-.3-11.882-1.484-11.882-2.901s5.078-2.6 11.882-2.905v4.627c.445.031 1.719.106 3.48.106 2.111 0 3.17-.087 3.368-.105V24.62c6.79.303 11.856 1.488 11.856 2.902 0 1.417-5.066 2.598-11.856 2.9m0-6.282V20h9.474v-6.315H67.042v6.314h9.474v4.14c-7.7.353-13.49 1.879-13.49 3.706s5.79 3.35 13.49 3.706V44.82h6.848V31.546c7.688-.354 13.464-1.878 13.464-3.703 0-1.826-5.776-3.35-13.464-3.705",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      d: "M28 .004C12.538.004.004 12.54.004 28 .004 43.462 12.538 55.996 28 55.996S55.995 43.462 55.995 28 43.461.004 28 .004m0 52.68a24.684 24.684 0 1 1 0-49.368 24.684 24.684 0 0 1 0 49.367",
      fill: "#FCA311"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      d: "M28 3.317a24.684 24.684 0 1 0 0 49.369 24.684 24.684 0 0 0 0-49.37M17.004 16.41h11.104c7.402 0 11.877 3.8 11.877 10.079 0 2.365-.658 4.37-1.854 5.958l-2.955-2.78a6.7 6.7 0 0 0 .741-3.178c0-4.13-2.725-6.485-7.931-6.485H21.07v8.433l-4.067 4.326zM37.61 39.59 28 29.98l-9.611 9.61h-4.752l13.035-13.594a1.88 1.88 0 0 1 2.656 0L42.363 39.59z",
      fill: "#293963"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      d: "M26.672 25.996 13.637 39.59h4.752l9.61-9.61 9.612 9.61h4.752L29.328 25.996a1.876 1.876 0 0 0-2.656 0",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      d: "M21.071 20.004h6.915c5.206 0 7.931 2.355 7.931 6.485a6.74 6.74 0 0 1-.741 3.178l2.955 2.78c1.196-1.589 1.854-3.593 1.854-5.958 0-6.279-4.475-10.079-11.877-10.079H17.004v16.353l4.067-4.326z",
      fill: "#fff"
    }
  )
] });
export {
  f as R
};
